import { useEffect } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import EntryNavLinks from '../../EntryNavLinks';
import NavLinks from '../../../meet/NavLinks';

import useOmeMeetOrgUnitEntryData from '../../../../state/omeMeetOrgUnitEntry/UseOmeMeetOrgUnitEntryData';
import useOmeMeetData from '../../../../state/omeMeet/UseOmeMeetData';

import useLeftNavModalData from '@usas/ui-web/state/leftNavModal/UseLeftNavModalData';

const useOrgUnitAdminPayments = () => {
  const navigate = useNavigate();
  const { omeMeetState } = useOmeMeetData();
  const { omeMeetOrgUnitEntryState } = useOmeMeetOrgUnitEntryData();
  const { leftNavModalState, setLeftNavModalState } = useLeftNavModalData();

  const redirectToPurchases = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (omeMeetState.route === '') {
      //OME Route
      navigate(EntryNavLinks.OU_ADMIN_PURCHASES);
    }
    else {
      //Meet Route
      navigate(NavLinks.OU_ADMIN_PURCHASES);
    }
  };

  const redirectToEntryStatus = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (omeMeetState.route === '') {
      //OME Route
      navigate(EntryNavLinks.OU_ADMIN_MEET_INFO, { state: { tryGet: true } });
    }
    else {
      //Meet Route
      navigate(NavLinks.OU_ADMIN_MEET_INFO, { state: { tryGet: true } });
    }
  }

  useEffect(() => {
    setLeftNavModalState({ ...leftNavModalState, formStateSaved: false });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    redirectToPurchases,
    redirectToEntryStatus,
    orgUnitId: omeMeetOrgUnitEntryState?.objData?.orgUnitId,
    omeMeetOrgUnitEntryId: omeMeetOrgUnitEntryState?.objData?.omeMeetOrgUnitEntryId
  };
};

export default useOrgUnitAdminPayments;